import { render, staticRenderFns } from "./ForceRefundPublic.vue?vue&type=template&id=37723637&"
import script from "./ForceRefundPublic.vue?vue&type=script&lang=js&"
export * from "./ForceRefundPublic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports